import { CloseCircleFilled } from "@ant-design/icons";
import {
  AssignedIcon,
  CompletedCaseStatus,
  CrossIcon,
  PendingCaseStatus,
  WaitingForReview,
} from "icons";

export const caseStatusColors = {
  assigned: {
    color: "#8996A9",
    icon: AssignedIcon,
  },
  open: { color: "#F4BD00", icon: PendingCaseStatus },
  closed: { color: "#22C55E", icon: CompletedCaseStatus },
  pending: { color: "#F4BD00", icon: PendingCaseStatus },
  waitingForReview: { color: "#FF8800", icon: WaitingForReview },
  unassigned: { color: "#F4BD00", icon: PendingCaseStatus },
};
export const reminderStatusColors = {
  PENDING: { color: "#F4BD00", icon: PendingCaseStatus },
  DONE: { color: "#22C55E", icon: CompletedCaseStatus },
};
export const usersStatusColors = {
  Inactive: { color: "#8996A9", icon: CloseCircleFilled },
  Active: { color: "#22C55E", icon: CompletedCaseStatus },
};
